"use client";
/*eslint-disable */
import React from "react";
import { Link, useLocation } from 'react-router-dom';

interface MenuItemProps {
  label: string;
  link: string;
  submenu?: { label: string; link: string }[];
}

const MenuItem: React.FC<MenuItemProps> = ({ label, link, submenu }) => {
  const location = useLocation();

  if (submenu) {
    return (
      <li className="nav-item" key={label}>
        <Link
          to={link}
          className="dropdown-toggle nav-link"
          onClick={(e) => e.preventDefault()}
        >
          {label}
        </Link>

        {/* <ul className="dropdown-menu">
          {submenu.map((subItem) => {
            const isActive = location.pathname === subItem.link;
            return (
              <li className="nav-item" key={subItem.label}>
                <Link
                  to={subItem.link}
                  className={`nav-link ${isActive ? "active" : ""}`}
                >
                  {subItem.label}
                </Link>
              </li>
            );
          })}
        </ul> */}
      </li>
    );
  }

  return (
    <li className="nav-item" key={label}>
      <Link to={link} className={`nav-link ${location.pathname === link ? "active" : ""}`}>
        {label}
      </Link>
    </li>
  );
};

export default MenuItem;
